import React, { Fragment } from "react";
import { useAppContext } from "../../helpers/account-context";

import { toPermalink } from "../../helpers/helper";
import { ResultLine, DetailLine, InfowinLine } from "./Mixin";

const CustomFieldRow = (props) => {
  const { itemField, hiddenLabel } = props;
  let fieldValue = itemField.value;
  if (itemField.field_type === "url") {
    fieldValue = <a href={fieldValue} target={`_blank`}>{fieldValue}</a>;
  } else if (itemField.field_type === "phone") {
    fieldValue = <a href={`tel:${fieldValue}`}>{fieldValue}</a>;
  } else if (itemField.field_type === "email") {
    fieldValue = <a href={`mailto:${fieldValue}`}>{fieldValue}</a>;
  }
  return (
    <Fragment>
      {!hiddenLabel && (
        <div className="cbmap-custom-field-name">{itemField.name}</div>
      )}
      <div className="cbmap-custom-field-value">{fieldValue}</div>
    </Fragment>
  );
};

export const CustomFieldsResult = (props) => {
  const { account } = useAppContext()
  const { item, hiddenLabel = false } = props;
  const customFields = account.custom_fields || [];
  return (
    <Fragment>
      {customFields.map((customField) => {
        if (!item.properties.fields || item.properties.fields.length === 0)
          return null;
        const itemField = item.properties.fields.find(
          (fd) => fd.name === customField.name
        );
        if (!itemField) return null;
        if (!itemField.value) return null;
        return (
          <ResultLine
            key={`cbmap-item_${toPermalink(itemField.name)}`}
            className={`cbmap-custom-field cbmap-item_${toPermalink(
              itemField.name
            )}`}
          >
            <CustomFieldRow itemField={itemField} hiddenLabel={hiddenLabel} />
          </ResultLine>
        );
      })}
    </Fragment>
  );
};

export const CustomFieldsDetail = (props) => {
  const { account } = useAppContext()

  const { item, hiddenLabel = false } = props;
  const customFields = account.custom_fields || [];

  return (
    <Fragment>
      {customFields.map((customField) => {
        if (!item.properties.fields || item.properties.fields.length === 0)
          return null;
        const itemField = item.properties.fields.find(
          (fd) => fd.name === customField.name
        );
        if (!itemField) return null;
        if (!itemField.value) return null;
        return (
          <DetailLine
            key={`cbmap-details_${toPermalink(itemField.name)}`}
            className={`cbmap-custom-field cbmap-details_${toPermalink(
              itemField.name
            )}`}
          >
            <CustomFieldRow itemField={itemField} hiddenLabel={hiddenLabel} />
          </DetailLine>
        );
      })}
    </Fragment>
  );
};

export const CustomFieldsInfowin = (props) => {
  const { account } = useAppContext()

  const { item, hiddenLabel = false } = props;
  const customFields = account.custom_fields || [];

  return (
    <Fragment>
      {customFields.map((customField) => {
        if (!item.properties.fields || item.properties.fields.length === 0)
          return null;
        const itemField = item.properties.fields.find(
          (fd) => fd.name === customField.name
        );
        if (!itemField) return null;
        if (!itemField.value) return null;
        return (
          <InfowinLine
            key={`cbmap-infowin_${toPermalink(itemField.name)}`}
            className={`cbmap-custom-field cbmap-infowin_${toPermalink(
              itemField.name
            )}`}
          >
            <CustomFieldRow itemField={itemField} hiddenLabel={hiddenLabel} />
          </InfowinLine>
        );
      })}
    </Fragment>
  );
};
